module.exports = __webpack_public_path__ + "static/media/yardnapha.6a2e7be1.png";